// MpfInput.props.ts
// Nearly all inputs have the same core props, types and emits.

export type InputSize = 'default' | 'small' | 'regular' | 'large' | number | undefined;
export type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6 | '1' | '2' | '3' | '4' | '5' | '6';
export type HeadingLevelSize = 's' | 'm' | 'l' | 'xl';
// `sr` is screen reader text, NOT for an aria attribute.
// There are occasions when we should use sr values over aria attributes
export interface MpfInputBaseProps {
  ariaDescribedby?: string;
  ariaLabel?: string;
  disabled?: boolean;
  errors?: string[];
  headingLevel?: HeadingLevel;
  headingLevelSize?: HeadingLevelSize;
  hint?: string;
  id?: string;
  initialValue?: string;
  label: string;
  modelValue?: string;
  name?: string;
  required?: boolean;
  // Renders a horizontal rule before the input / fieldset (form-builder only).
  separator?: boolean;
  size?: InputSize;
  srDescribedby?: string;
  srHint?: string;
  srLabel?: string;
  type?: string;
  width?: InputSize;
}

// Defaults MUST be values (NOT factories) when using withDefaults
export const mpfInputDefaults = {
  required: false,
  modelValue: '',
  // @ts-expect-error
  errors: () => [] as string[], // this is valid, IDE issues with factory functions
  ariaDescribedby: '',
} satisfies Partial<MpfInputBaseProps>;

// Typed emits for defineEmits<MpfTextInputEmits>()
export type MpfInputEmits = {
  (e: 'update:modelValue', value: string): void;
  (e: 'blur', ev: Event): void;
  (e: 'focus', ev: Event): void;
  (e: 'input', ev: Event): void;
  (e: 'change', ev: Event): void;
};
